<div class="notification-container" [ngClass]="{ open: isNotificationOpen }">
    <div class="notification-header-container">
        <h1 class="notification-header">{{ 'text.notifications' | translate }}</h1>

        <div
            class="flex items-center space-x-[0.375rem]"
            [ngClass]="isAllNotificationRead ? 'text-[#C5C5C5]' : 'text-[#007DA9]'">
            <mat-icon svgIcon="double-tick"></mat-icon>
            <button
                type="button"
                class="font-medium text-lg"
                [disabled]="isAllNotificationRead"
                (click)="markAllAsRead()">
                {{ 'button.markAllAsRead' | translate }}
            </button>
        </div>
    </div>

    <div class="notification-item-container custom-scroll" [ngClass]="{ open: isNotificationOpen }">
        @if (!isLoading && notificationData.length > 0) {
            @for (item of notificationData; track item; let last = $last) {
                <button type="button" class="notification-item" (click)="onNotificationClick(item)">
                    <div>
                        <p
                            class="font-bold font-lato text-base ellipsis-line-2"
                            [innerHTML]="item.title"
                            [ngClass]="item.isRead ? 'text-[#5F5B5B]' : 'text-[#231F20]'"></p>
                        <p class="mt-4 text-[#5D6568] font-lato font-normal text-sm">
                            {{ item.broadcastDate | date: COURSE_DATE_FORMAT }},
                            {{ item.broadcastDate | date: TWELVE_HOURS_FORMAT }}
                        </p>
                    </div>

                    <div class="w-4">
                        @if (!item.isRead) {
                            <div class="w-[0.625rem] h-[0.625rem] bg-[#00AFED] rounded-full mt-[0.375rem]"></div>
                        }
                    </div>
                </button>
            }
        }

        @if (!isLoading && notificationData.length === 0) {
            <div class="w-full flex justify-center h-96 items-center border-t-[1px] border-t-[#E7E7E7]">
                <app-empty-result [line2]="''" [line1]="'text.noNotification'"></app-empty-result>
            </div>
        }

        @if (isLoading) {
            <div class="animate-pulse space-y-4 rounded-2xl mt-4">
                @for (item of [0, 1, 2, 3, 4, 5]; track item) {
                    <div class="loader h-9 w-full rounded-md"></div>
                }
            </div>
        }
    </div>

    <div class="notification-footer">
        <a [routerLink]="['notification-listing']" (click)="onSeeAllNotificationClick()">{{
            'button.seeAllNotification' | translate
        }}</a>
    </div>
</div>
